import axios from "axios";
//http://api.tejaan.sa:4000

// http://localhost/
// const baseURL = axios.create({ baseURL: "https://tejaan.sa/" });

// http://104.248.166.202

// const baseURL = axios.create({ baseURL: "http://localhost/" });
// abu6: https://abu6.com/
// shelly : https://shelly-az.com/
// care clothes : https://lamsahsa.com

// tejan : https://tejaan.sa/
// جمعية التثقيف : 
//http://104.248.166.202/

// جمعية راحة
// http://46.101.61.220/

// megas store : http://megastore-app.com:4050

let baseStringURL = 'https://abu6.com';

const baseURL = axios.create({ baseURL: baseStringURL });

// const baseURL = axios.create({ baseURL: "http://demo.megastore-app.com:3000" });
// const baseURL = axios.create({ baseURL: "http://api.abayatlyan.com:3000" });
// const baseURL = axios.create({ baseURL: "http://localhost" });
// const baseURL = axios.create({ baseURL: "https://api.yly.sa:3433/api/v1/" });
//  const baseURL = axios.create({ baseURL: "https://api.yly.sa:3433/api/v1/" });

// const baseURL = axios.create({ baseURL: "https://abu6.com/" });

// const baseURL = axios.create({ baseURL: "http://167.172.53.107" });

// const baseURL = axios.create({ baseURL: "http://143.110.174.151" });

export default baseURL;

export { baseStringURL };
